import { Navigate, useRoutes } from "react-router-dom";

import Login from "./Pages/Login";
import SignUp from "./Pages/Sign Up";
import SetupAccount from "./Pages/Sign Up/setup-account";
import LoginWithUniqueContactID from "./Pages/Login/login-with-unique-contact-ID";
import PartnerSignUp from "./Pages/Login/partner-signup";
import Welcome from "./Pages/Welcome";
import Unclaimed from "./Pages/Unclaimed";
import Banking from "./Pages/Banking";
// import BankMigration from "./Pages/Banking/bank-migration";
import Home from "./Pages/Home";
import CreditBuilder from "./Pages/Credit Builder";
import Profile from "./Pages/Profile";
import PersonalInformation from "./Pages/Personal Information";
import ConnectedAccountsPage from "./Pages/Connected Accounts";
import AddCash from "./Pages/Cash Transaction Pages/add-cash";
import CashOut from "./Pages/Cash Transaction Pages/cash-out";
import VenmoTransfer from "./Pages/Cash Transaction Pages/venmo-transfer";
import BankingLimits from "./Pages/Banking Limits";
import DirectDeposit from "./Pages/Direct Deposit";
import RecurringDepositsPage from "./Pages/Recurring Deposits";
import ManageCards from "./Pages/Manage Cards";
import RentPayment from "./Pages/Rent Payment";
import RentPaymentDetails from "./Pages/Rent Payment/rent-payment-details";
import RentPaymentActivity from "./Pages/Rent Payment/rent-payment-activity";
import ManagePayeePage from "./Pages/Manage Payee";
import Deals from "./Pages/Deals";
import StakeSaver from "./Pages/Stake Saver";
import SSO from "./Pages/SSO";
import NeighborhoodNetwork from "./Pages/Neighborhood Network";
import NeighborhoodNetworkCards from "./Pages/Neighborhood Network/cards";
import NeighborhoodNetworkBrandsAndOffers from "./Pages/Neighborhood Network/brands-and-offers";
import NeighborhoodNetworkRewards from "./Pages/Neighborhood Network/rewards";
import NeighborhoodNetworkOffersNearYou from "./Pages/Neighborhood Network/offers-near-you";
import InsuranceManage from "./Pages/Insurance/Manage";
import MyUtilitiesManage from "./Pages/MyUtilities/manage";
import VerifyStakeChecking from "./Pages/Verify Stake Checking";
import ErrorPage from "./Components/Others/error-page";

import AppComponentWrapper from "./Organisms/Wrappers/app-component-wrapper";

import { useAppUtilityContext } from "./Contexts/AppUtilityContext";
import { RedirectContextProvider } from "./Contexts/RedirectContext";

function Routes() {
  const {
    appUtilityProps: { hideDealsRoutes },
  } = useAppUtilityContext();

  let routes = useRoutes([
    {
      path: "/",
      element: <RedirectContextProvider />,
      children: [
        { path: "login", element: <Login /> },
        { path: "welcome", element: <Welcome /> },
        { path: "welcome/find-a-home", element: <Welcome /> },
        { path: "unclaimed", element: <Unclaimed /> },
        { path: "setup-account", element: <SetupAccount /> },
        { path: "apply-stake-checking", element: <SSO applyStakeChecking /> },
        { path: "verify-stake-checking", element: <VerifyStakeChecking /> },
        // { path: "bank-account-migration", element: <BankMigration /> },
        ...(hideDealsRoutes ? [] : [{ path: "deals/setup-stake-saver", element: <SSO setupStakeSaver /> }]),
        {
          path: "/",
          element: <AppComponentWrapper />,
          children: [
            { path: "/", element: <Navigate to="login" /> },
            { path: "cash-out", element: <CashOut /> },
            { path: "venmo-transfer", element: <VenmoTransfer /> },
            { path: "credit-builder", element: <CreditBuilder /> },
            { path: "home", element: <Home /> },
            ...(hideDealsRoutes
              ? []
              : [
                  {
                    path: "deals",
                    children: [
                      { path: "", element: <Deals /> },
                      { path: "stake-saver", element: <StakeSaver /> },
                      { path: "stake-checking", element: <ManageCards /> },
                      {
                        path: "neighborhood-network",
                        children: [
                          { path: "", element: <NeighborhoodNetwork /> },
                          { path: "linked-cards", element: <NeighborhoodNetworkCards /> },
                          { path: "brands-and-offers", element: <NeighborhoodNetworkBrandsAndOffers /> },
                          { path: "rewards", element: <NeighborhoodNetworkRewards /> },
                          { path: "offers-near-you", element: <NeighborhoodNetworkOffersNearYou /> },
                        ],
                      },
                      { path: "insurance/manage", element: <InsuranceManage /> },
                      { path: "my-utilities/manage", element: <MyUtilitiesManage /> },
                    ],
                  },
                ]),
            {
              path: "banking",
              children: [
                { path: "", element: <Banking /> },
                { path: "connected-accounts", element: <ConnectedAccountsPage /> },
                { path: "add-cash", element: <AddCash /> },
                { path: "banking-limits", element: <BankingLimits /> },
                { path: "direct-deposit", element: <DirectDeposit /> },
                { path: "recurring-deposits", element: <RecurringDepositsPage /> },
                { path: "manage-cards", element: <ManageCards /> },
              ],
            },
            {
              path: "one-time-payment",
              element: <RentPayment />,
            },
            {
              path: "recurring-payment",
              children: [
                {
                  path: "",
                  element: <RentPayment isRecurringTransaction />,
                },
                {
                  path: "view/:recurringId",
                  element: <RentPaymentDetails />,
                },
              ],
            },
            { path: "rent-payment-activity", element: <RentPaymentActivity /> },
            { path: "manage-payees", element: <ManagePayeePage /> },
            {
              path: "profile",
              children: [
                { path: "", element: <Profile /> },
                { path: "personal-information", element: <PersonalInformation /> },
              ],
            },
          ],
        },
      ],
    },
    { path: "sign-up", element: <SignUp /> },
    { path: "login-with-unique-id", element: <LoginWithUniqueContactID /> },
    { path: "partner-signup", element: <PartnerSignUp /> },
    { path: "*", element: <ErrorPage isPageNotFound /> },
  ]);
  return routes;
}

export default Routes;
